import React from "react";
import { RxCross2 } from "react-icons/rx";
import { DimensionModel, RoleResponseModel } from "../../_core/_model.ts";
import { useAppContext } from "../../context/AppContext.tsx";
import TooltipButton from "../Tools/TooltipButton.tsx";
import RoleDetailsOnTitle from "./RoleDetailsOnTitle.tsx";

interface request {
    roleIDS: string,
    tClass: string,
    emptyUI: any
}
export function GroupExpandView({ roleIDS, tClass, emptyUI }: request) {
    const { dimensions, roles } = useAppContext();
    const getCell = (roleId: number | null, dim: DimensionModel) => {
        let role = (typeof roles?.find((x) => x.roleID == roleId) != 'undefined') ?
            roles?.find((x) => x.roleID == roleId) : null;
        if (role != null && dim.dimensionCode != role.dataMapCode)
            role = null;
        return (
            role == null ?
                <TooltipButton title="Empty Cell"><span>-</span></TooltipButton> :
                <div
                    key={role.roleName}
                    className="d-flex justify-content-between align-items-start p-1 rounded"
                    style={{
                        background: dimensions.find((d) => d.dimensionCode == role.dataMapCode)?.bg,
                        color: dimensions.find((d) => d.dimensionCode == role.dataMapCode)?.color,
                        borderLeft: '4px solid ' + (dimensions.find((d) => d.dimensionCode == role.dataMapCode)?.color || '#333'),
                        transition: 'all 0.2s ease',
                        width: "100%"
                    }}
                >
                    <TooltipButton maxWidth={750} fullWidth={true} title={role.roleID == null ? "" : <RoleDetailsOnTitle roleId={role.roleID?.toString()} />}>
                        <div className="d-flex flex-column w-100">
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div className="d-flex flex-row gap-1 align-items-center text-truncate" style={{ fontSize: "10px" }}>
                                    <strong>{role.roleName}</strong>
                                </div>
                            </div>
                        </div>
                    </TooltipButton>
                </div>
        )
    }

    return (
        <div className={tClass}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                <thead>
                    <tr>
                        {
                            dimensions.map((x) => (
                                <th className="border p-2" key={x.dimensionCode}>
                                    {x.dimensionName}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        roleIDS.isEmpty() ?
                            <tr>
                                <td colSpan={dimensions.length}>{
                                    emptyUI
                                }
                                </td>
                            </tr> :
                            (() => {
                                const roleIdList = roleIDS.split(",").map((r) => parseInt(r));
                                const dimensionRoleMap: { [dimensionCode: string]: RoleResponseModel[] } = {};

                                // Group roles by dimension
                                for (const id of roleIdList) {
                                    const role = roles.find((r) => r.roleID === id);
                                    if (role && dimensions.some(d => d.dimensionCode === role.dataMapCode)) {
                                        if (!dimensionRoleMap[role.dataMapCode]) {
                                            dimensionRoleMap[role.dataMapCode] = [];
                                        }
                                        dimensionRoleMap[role.dataMapCode].push(role);
                                    }
                                }

                                // Find max number of rows required
                                const maxRows = Math.max(...dimensions.map(dim => (dimensionRoleMap[dim.dimensionCode]?.length || 0)));

                                // Render rows
                                return Array.from({ length: maxRows }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {dimensions.map((dim) => {
                                            const role = dimensionRoleMap[dim.dimensionCode]?.[rowIndex];
                                            return (
                                                <td key={dim.dimensionCode + rowIndex} className="border p-2">
                                                    {role ? getCell(role.roleID, dim) :
                                                        <TooltipButton title="Empty Cell"><span>-</span></TooltipButton>}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ));
                            })()
                    }
                </tbody>
            </table>
        </div>
    )
}

export default GroupExpandView;